import type { Role } from '@/entities/user';

export const reportsAccessRoles = ['admin', 'manager', 'accountant'] as unknown as readonly Role[];
